<template>
   <transition name="modal">
        <div id="addProcessorDefinitionToTalkgroup" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="addAi" v-t="'message.title_add_ai_setting'">
                    </div>
                    <div v-else v-t="'message.title_edit_ai_setting'">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_select_ai'">
                                        </div>
                                        <div v-if="listType == 1" class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="processorDefinitionListTreeData.length > 0" class="inner-panel-dialog">
                                    <el-tree
                                        class="dialog-tree"
                                        :data="processorDefinitionListTreeData"
                                        highlight-current
                                        @node-click="handleNodeClick"
                                        :render-content="renderContent"
                                        :empty-text="emptyText">
                                    </el-tree>
                                </div>
                                <div v-else>
                                    <div class="empty-place" v-t="'message.info_empty_cooperated_ai_group'"></div>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left">
                                            {{ title }}
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.common_action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-user" class="inner-panel-dialog" :class="inner-panel-dialog-wide">
                                    <div v-if="processorDefinitionListTreeData.length == 0">
                                    </div>
                                    <div v-else-if="editTagList.length == 0" class="default-message" v-html="$t('message.common_action_add_ai')">
                                    </div>
                                    <div v-else class="selected-item-field" style="height: calc(100% - 20px)">
                                        <div class="userTag" v-for="tag in editTagList" v-bind:key="tag.setting.id">
                                            <span class="userTag-name">{{ tag.label }}</span>
                                            <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';
import processorTemplateUtil from './pc/setting/ai-app/AiAppSettingUtil.js';

export default {
    data() {
        return {
            disableSave: true,
            selectedTitle: commonUtil.getMessageText(this.$i18n,"title_groupAi"),
            processorDefinitionListTreeData: [],
            editTagList: [],
            originalProcessorDefinitionIdSet: new Set(),
            emptyText: '',
        };
    },
    methods: {
        handleChangeSelectedAi() {
            this.disableSave = false;
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = node.data.iconUrl;
            return h("span", { style: { display: "flex" } }, [h("img", { attrs: { src: objectIcon ,height: "20px", style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        findUser() {
        },
        selectTagAll() {
        },
        removeAllUserTag() {
            this.editTagList = [];
            this.handleChangeSelectedAi();
        },
        removeUserTag(tag) {
            let newEditTagList = [];
            for (let tagElement of this.editTagList) {
                if (tagElement.setting.id != tag.setting.id) {
                    newEditTagList.push(tagElement);
                }
            }
            this.editTagList = newEditTagList;
            this.handleChangeSelectedAi();
        },
        handleNodeClick(data) {
            // check speech to text first
            if (this.talkgroupAttribute.talkgroupOptions.speechToTextEngine == 0) {
                if (processorTemplateUtil.needStt(data.setting.definition)) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_enable_speechToText"));
                    return;
                }
            }
            for (let tag of this.editTagList) {
                if (data.setting.id == tag.setting.id) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_ai_already_added"));
                    return;
                }
            }
            this.editTagList.push(data);
            this.handleChangeSelectedAi();
        },
        saveUpdatedInfo() {
            let newProcessorDefinitionIds = [];
            let removeProcessorDefinitionIds = [];
            for (let tag of this.editTagList) {
                if (!this.originalProcessorDefinitionIdSet.has(tag.setting.id)) {
                    newProcessorDefinitionIds.push(tag.setting.id);
                }
            }
            for (let id of this.originalProcessorDefinitionIdSet) {
                // search and check whether editTagList still has it
                let noLongerExist = true;
                for (let tag of this.editTagList) {
                    if (id == tag.setting.id) {
                        noLongerExist = false;
                        break;
                    }
                }
                if (noLongerExist) {
                    removeProcessorDefinitionIds.push(id);
                }
            }
            this.$emit('update' , newProcessorDefinitionIds, removeProcessorDefinitionIds);
        },
    },
    components: {
    },
    created: function() {
        for (let processorDefinition of this.$root.store.processorDefinitionList) {
            if (processorDefinition.serviceId == constants.VAULT_SERVICE_STORAGE) {
                continue;
            }
            let iconUrl = processorTemplateUtil.getDefaultIconUrl();
            if ('iconUrl' in processorDefinition.definition) {
                iconUrl = processorDefinition.definition.iconUrl;
            }
            let treeElement = {
                label: processorDefinition.displayName,
                iconUrl: iconUrl,
                setting: processorDefinition,
            };
            this.processorDefinitionListTreeData.push(treeElement);
        }
        for (let processorDefinitionId of this.talkgroupAttribute.processorDefinitionIds) {
            for (let tag of this.processorDefinitionListTreeData) {
                if (processorDefinitionId == tag.setting.id) {
                    this.editTagList.push(tag);
                    this.originalProcessorDefinitionIdSet.add(tag.setting.id);
                    break;
                }
            }
        }
        this.emptyText = commonUtil.getMessageText(this.$i18n, 'info_empty_cooperated_ai_group');
    },
    props: ['appData' , 'talkgroupAttribute' , 'addAi' ]
}
</script>


<style scoped>
.dialoginputfield {
    height: 60px;
}

.findedUser-record {
  cursor: pointer;
}
.findedUser-record:hover {
  background-color: #ecf1fa;
}

.findedUser {
  padding: 10px 20px;
}

.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
.empty-place {
    padding: 6px;
    font-size: 12px;
    height: 28px;
    color: #848991;
    padding-left: 20px;
    vertical-align: middle;
    display: table-cell;
}

.el-input-group {
    width: 650px;
    padding-left: 20px;
    padding-bottom: 0;
}

.el-select-dropdown__item.selected {
    color: #000000;
}

.el-select-dropdown__item {
    font-size: 14px;
}

.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>
